import React from 'react';

const PayersContent = () => {
  return (
    <div>PayersContent</div>
  )
}

export default PayersContent